import BaseService from './baseService';

class SubmissionNote extends BaseService {
	async getSubmissionNoteBySubmissionId(payload, opts) {
    this.endPoint = '/submission-note?submission_id='+payload.submission_id;
		return this.get(opts);
  };
  async createSubmissionNote(payload) {
    this.endPoint = '/submission-note';
    return await this.post(payload);
  }
  async deleteSubmissionNote(id, opts={}) {
    this.endPoint = '/submission-note';
    return this.delete(id, opts);
  }
}

export default new SubmissionNote();